import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { App } from "@/App";
import { initTheme } from "@/lib/theme";
import "@/index.css";

// Applied before the first paint, synchronously, so the initial render never flashes the
// wrong palette while React boots.
initTheme();

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <App />
  </StrictMode>,
);
